import { render, staticRenderFns } from "./GoodsPut.vue?vue&type=template&id=69ff0878&"
import script from "./GoodsPut.vue?vue&type=script&lang=js&"
export * from "./GoodsPut.vue?vue&type=script&lang=js&"
import style0 from "./GoodsPut.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports